import { IPersonalInfo, InputFieldConfig } from '../../../../../types';
import { StudentState } from '../../../../../store/student/types';

type Fields = Pick<
  IPersonalInfo,
  | 'hasEnglishTest'
  | 'englishTestType'
  | 'englishTestTypeOther'
  | 'englishTestNotReqdReason'
  | 'englishTestNotReqdReasonOther'
  | 'qualification'
  | 'qualificationOther'
>;

type Visible = Record<
  | 'hasEnglishTest'
  | 'englishTestType'
  | 'englishTestTypeOther'
  | 'englishTestNotReqdReason'
  | 'englishTestNotReqdReasonOther'
  | 'qualification'
  | 'qualificationOther',
  boolean
>;

// type Mandatory = Record<
//   'hasEnglishTest' | 'englishTestType' | 'englishTestTypeOther' | 'englishTestNotReqdReason',
//   boolean
// >;

export function getPageStatus(
  config: StudentState['config'],
  fields: Fields,
): {
  complete: boolean;
  visible: Visible;
} {
  const {
    hasEnglishTest,
    englishTestType,
    englishTestTypeOther,
    englishTestNotReqdReason,
    englishTestNotReqdReasonOther,
    qualification,
    qualificationOther,
  } = fields;

  const {
    HasEnglishTest: hasEnglishTestConfig,
    EnglishTestType: englishTestTypeConfig,
    EnglishTestTypeOther: englishTestTypeOtherConfig,
    EnglishTestNotReqdReason: englishTestNotReqdReasonConfig,
    EnglishTestNotReqdReasonOther: englishTestNotReqdReasonOtherConfig,
    Qualification: qualificationConfig,
  }: {
    HasEnglishTest: InputFieldConfig;
    EnglishTestType: InputFieldConfig;
    EnglishTestTypeOther: InputFieldConfig;
    EnglishTestNotReqdReason: InputFieldConfig;
    EnglishTestNotReqdReasonOther: InputFieldConfig;
    Qualification: InputFieldConfig;
  } = config.Checklist.PersonalInfo.Page6;

  const visible: Visible = {
    hasEnglishTest: hasEnglishTestConfig?.visible ?? true,
    englishTestType: (englishTestTypeConfig?.visible ?? true) && hasEnglishTest === true,
    englishTestTypeOther: (englishTestTypeOtherConfig?.visible ?? true) && englishTestType === 'Other',
    englishTestNotReqdReason: (englishTestNotReqdReasonConfig?.visible ?? true) && hasEnglishTest === false,
    englishTestNotReqdReasonOther: (englishTestNotReqdReasonOtherConfig?.visible ?? true) && hasEnglishTest === false,
    qualification:
      (qualificationConfig?.visible ?? true) &&
      hasEnglishTest === false &&
      englishTestNotReqdReason === 'Previous test',
    qualificationOther: (qualificationConfig?.visible ?? true) && qualification === 'Other',
  };

  // const mandatory: Mandatory = {
  //   hasEnglishTest: hasEnglishTestConfig?.mandatory ?? true,
  //   englishTestType: englishTestTypeConfig?.mandatory ?? true,
  //   englishTestTypeOther: englishTestTypeOtherConfig?.mandatory ?? true,
  // };

  // prettier-ignore
  // const complete = (!visible.hasEnglishTest || !mandatory.hasEnglishTest || hasEnglishTest !== undefined) &&
  //   typeof hasEnglishTest === 'boolean' && (hasEnglishTest === false ?
  //     (!visible.englishTestNotReqdReason || !mandatory.englishTestNotReqdReason || englishTestNotReqdReason !== '') :
  //     (!visible.englishTestType || !mandatory.englishTestType || englishTestType !== '') &&
  //     (!visible.englishTestTypeOther || !mandatory.englishTestTypeOther || (englishTestType === 'Other' && englishTestTypeOther !== '')));

  const complete = (() => {
    if (englishTestType && hasEnglishTest) {
      if (englishTestType !== 'Other') return true;
      return englishTestTypeOther !== '';
    }
    if (englishTestNotReqdReason && !hasEnglishTest) {
      if (englishTestNotReqdReason !== 'Other' && englishTestNotReqdReason !== 'Previous test') return true;
      if (englishTestNotReqdReason === 'Other') return englishTestNotReqdReasonOther !== '';
      if (englishTestNotReqdReason === 'Previous test') {
        if(qualification) {
          if (qualification !== 'Other') return true;
          return qualificationOther !== '';
        }
      }
    }
    return false;
  })();
  return {
    complete,
    visible,
  };
}
